import axios from 'axios';
import AppConfig from "../../AppConfig";

let URL = AppConfig.HOST_CLIENT_API() + 'auth/faktury/'

export default {

    pobierzStawkiVat(){
        return axios({
            method: 'get',
            url: URL+'stawkiVat'
        })
    },



}


// WEBPACK FOOTER //
// ./src/modules/fakturaModule/FakturaService.js